import { Role } from "../../business/role/Role.js";


const memburshipBenefits = [
    "Unlimited Panda games",
    "Unlimited game review",
    "No ads",
    "New reactions & name colours",
];

const goldBenefits = [
    "No ads",
    "Coloured name",
    "All in-game reactions",
    "Unlimited Panda games",
];


export interface Product {
    role?: Role;
    priceUSD: number;
    unit: string;
    priceID: string;
    legacyPriceIDs: string[];
    isSubscription: boolean;
    isTestProduct: boolean;
    benefits: string[];
}


export const allProducts = getAllProducts();


function getAllProducts(): Product[] {
    const products: Product[] = [];
    for (const testMode of [true, false]) {
        products.push(getMonthlyMemburship(testMode));
        products.push(getYearlyMemburship(testMode));
        products.push(getGoldPurchase(testMode));
    }
    return products;
}


export function findProduct(priceID: string): Product {
    for (const product of allProducts) {
        if (product.priceID === priceID)
            return product;
        if (product.legacyPriceIDs.includes(priceID))
            return product;
    }
    throw new Error(`Unknown product with priceID ${priceID}`);
}


export function getMonthlyMemburship(testMode: boolean): Product {
    return {
        role: Role.MEMBUR,
        priceUSD: 8,
        unit: "/ month",
        priceID: testMode ? "price_1TWujc7xDZx4Msf89DJX5AmM" : "price_1TXFTkGI9cBQYwYtYeuJCHOU",
        legacyPriceIDs: testMode ? [
            "price_1SAii27xDZx4Msf8s35pbeha",
        ] : [
            "price_1Q4lBOGI9cBQYwYtaYllZQdk",
            "price_1Q5aUlGI9cBQYwYtzbOGV9ym",
        ],
        isSubscription: true,
        isTestProduct: testMode,
        benefits: memburshipBenefits,
    };
}


export function getYearlyMemburship(testMode: boolean): Product {
    return {
        role: Role.MEMBUR,
        priceUSD: 48,
        unit: "/ year",
        priceID: testMode ? "price_1TXFNx7xDZx4Msf8yhcbpags" : "price_1TXFUIGI9cBQYwYtXcTsAUK0",
        legacyPriceIDs: testMode ? [
            "price_1SAiis7xDZx4Msf8Zt2AGI4U",
        ] : [
            "price_1QkSZoGI9cBQYwYt0hF2T5t5",
            "price_1OqOgBGI9cBQYwYtEW3FGMcY",
        ],
        isSubscription: true,
        isTestProduct: testMode,
        benefits: memburshipBenefits,
    };
}


export function getGoldPurchase(testMode: boolean): Product {
    return {
        role: Role.GOLD,
        priceUSD: 24,
        unit: "one-time",
        priceID: testMode ? "price_1TXFOs7xDZx4Msf8Ymtm0ziD" : "price_1SelS6GI9cBQYwYtB3I3Sp5y",
        legacyPriceIDs: testMode ? [
            "price_1SelPL7xDZx4Msf8fd6u5Hnx",
        ] : [],
        isSubscription: false,
        isTestProduct: testMode,
        benefits: goldBenefits,
    };
}


export function getMemburshipYearlyPriceAsMonthly(testMode: boolean): string {
    const yearlyMemburship = getYearlyMemburship(testMode);
    const yearlyMonthPrice = Math.ceil(100 * yearlyMemburship.priceUSD / 12) / 100;
    return `$${yearlyMonthPrice.toFixed(2)} / month`;
}
